export default __webpack_public_path__ + "static/media/Ballroll_00330.a9ea52a2.png";